import MessageBus from './messagebus';

export default class FilterBus extends MessageBus {
    constructor (filter) {
        super();

        this.filter = filter;
    }

    receiveMessage (channel, message) {
        var output = this.filter[channel](message);

        if (output) this.sendMessage(output.channel, output.message);
    }
}
